import { UseFormReturn } from 'react-hook-form'

import { DepositOverviewPanel } from '../components/DepositOverviewPanel'
import { PositionOverview } from '../logic/types'
import { TokenWithBalance } from '@/domain/common/types'
import { Token } from '@/domain/types/Token'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { SparkRewardCampaign } from '@/ui/molecules/spark-reward-pill/SparkRewardPill'

export interface DepositViewProps {
  initialToken: Token
  depositAsset: Token
  selectableAssets: TokenWithBalance[]
  assetsFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  actionsViewState: ActionsViewState
  currentPositionOverview: PositionOverview
  updatedPositionOverview?: PositionOverview
  relatedCampaigns: SparkRewardCampaign[]
}

export function DepositView({
  initialToken,
  depositAsset,
  selectableAssets,
  assetsFields,
  form,
  actionsViewState,
  currentPositionOverview,
  updatedPositionOverview,
  relatedCampaigns,
}: DepositViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>{`Deposit ${initialToken.symbol}`}</DialogTitle>

      <FormAndOverviewWrapper>
        <DialogForm form={form} assetsFields={assetsFields} selectorAssets={selectableAssets} />
        <DepositOverviewPanel
          depositAsset={depositAsset}
          currentPositionOverview={currentPositionOverview}
          updatedPositionOverview={updatedPositionOverview}
          relatedCampaigns={relatedCampaigns}
        />
      </FormAndOverviewWrapper>

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
